import Vue from 'vue';
import {Message} from 'element-ui';

Vue.directive('move-dialog', {
    inserted: function (el, binding, vnode) {
        if (binding.value.move) {
            $(el).find('.el-dialog__header').on('mousedown.dialog.', function (e) {
                if (e.which === 3) {
                    return false
                }
                let isMove = true;
                let div_x = e.pageX - $(el).find('.el-dialog').offset().left;
                let div_y = e.pageY - $(el).find('.el-dialog').offset().top;
                $(document).mousemove(function (e) {
                    if (isMove) {
                        let obj = $(el).find('.el-dialog');
                        let top = e.pageY - div_y;
                        let left = e.pageX - div_x;
                        if (top <= 0) {
                            top = 0
                        } else if (top >= $(document).height() - $(el).find('.el-dialog').height()) {
                            top = $(document).height() - $(el).find('.el-dialog').height()
                        }
                        if (left <= 0) {
                            left = 0
                        } else if (left >= $(document).width() - $(el).find('.el-dialog').width()) {
                            left = $(document).width() - $(el).find('.el-dialog').width()
                        }
                        obj.css({"left": left, "top": top});
                    }
                }).mouseup(
                    function () {
                        isMove = false;
                    });
            });
        }
    },
    unbind: function (el) {
        $(el).find('.el-dialog__header').off('mousedown.dialog')
    }
});

Vue.directive('window-click', {
    inserted: function (el, binding, vnode) {

        let data = binding.value;
        let evAlias = binding.arg || 'window-click';
        if (typeof data === 'object') {
            $(document).on('click.' + evAlias, data.el, () => {
                data.fun();
            })
        } else {
            $(document).on('click.' + evAlias, () => {
                data();
            })
        }
    },
    unbind: function (el, binding, vnode) {
        let evAlias = binding.arg || 'window-click';
        $(document).off('click.' + evAlias)
    }
});

let searchTime = null;
Vue.directive('search', {
    inserted: function (el, binding, vnode) {
        let fun = binding.value;
        let isEnt = 'ent' in binding.modifiers;
        let flag = true;
        let eventName = binding.arg || 'search';
        $(el).on('compositionstart.' + eventName, function () {
            flag = false;
        });
        $(el).on('compositionend.' + eventName, function () {
            flag = true;
        });

        function throttle() {
            clearTimeout(searchTime);
            searchTime = setTimeout(function () {
                if (flag) {
                    fun();
                }
            }, 300)
        };

        function keyup(event) {
            let code = event.keyCode;
            if (code === 13) {
                fun();
            }
            ;
        }

        if (isEnt) {
            $(el).on('input.' + eventName, 'input', throttle);
            $(el).on('keyup.' + eventName, 'input', keyup);
        } else {
            $(el).on('input.' + eventName, throttle);
            $(el).on('keyup.' + eventName, keyup);
        }
    },
    unbind: function (el, binding, vnode) {
        let eventName = binding.arg || 'search';
        $(el).off('input.' + eventName);
        $(el).off('compositionstart.' + eventName);
        $(el).off('compositionend.' + eventName);
        $(el).off('keyup.' + eventName);
    }
});
